import { withParams } from 'vuelidate/lib'
import moment from 'moment'

const MIN_DATE = '1900-01-01'

export default withParams({ type: 'birthDateValidator' }, date => date.isBetween(MIN_DATE, moment()))
